export default "__VITE_ASSET__CZvA8CIg__"